export default {
  common: {
    search: 'Search',
    reset: 'Reset',
    create: 'Create',
    createTime: 'Created At',
    edit: 'Edit',
    view: 'View',
    remove: 'Remove',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    actions: 'Actions',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    online: 'Online',
    offline: 'Offline',
    toVerify: 'To Verify',
    addRow: 'Add Row',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    version: 'Version',
    remark: 'Remark',
    required: 'Required',
    type: 'Type',
    priority: 'Priority',
    publish: 'Publish',
    compare: 'Compare',
    enabled: 'Enabled',
    disabled: 'Disabled',
    permanent: 'No expiry',
    syntaxTest: 'Syntax Test',
    loadFailed: 'Failed to load data',
    syncFromTemplate: 'Sync from Template',
    totalItems: 'Total {total} items',
    on: 'On',
    off: 'Off',
    test: 'Test',
    delete: 'Delete',
    scene: 'Scene',
    custom: 'Custom',
    submit: 'Submit',
    pleaseSelect: 'Please select',
    pleaseInput: 'Please input',
    noData: 'No data',
  },
  layout: {
    productName: 'Risk Decision System',
    logoText: '',
    adminConsole: 'Admin Console',
    collapse: 'Collapse',
    expand: 'Expand',
    language: 'Language',
    zhCN: '中文',
    enUS: 'English',
    bizRealtimeTxn: 'Real-time Txn',
    bizCompliance: 'Compliance',
    userName: 'Admin',
    keepOneTab: 'Keep at least one tab open',
  },
  menuGroup: {
    architecture: 'System Architecture',
    access: 'Scene Access',
    featurePlatform: 'Feature Platform',
    ruleCenter: 'Rule Center',
    rule: 'Rules',
    decision: 'Decision',
    audit: 'Audit & Publish',
    verify: 'Verification',
    system: 'System',
  },
  menu: {
    systemArchitecture: 'System Architecture',
    home: 'Home',
    scenes: 'Scenes',
    accessPoints: 'Access Points',
    sceneDicts: 'Dictionary',
    merchantThresholds: 'Merchant Thresholds',
    rules: 'Rule List',
    strategies: 'Strategy',
    features: 'Feature Fields',
    featureRates: 'Rate Config',
    decisionTrees: 'Decision Flow',
    decisionPublish: 'Decision Publish',
    merchantRules: 'Merchant Custom Rules',
    verifyTraceSingle: 'Single Trace',
    verifyExecutionInstances: 'Execution Instances',
    verifyConclusions: 'Risk Conclusions',
    verifySimulate: 'Simulation',
    verifyLineage: 'Lineage Query',
    verifyTraceBatch: 'Batch Trace',
    verifyVelocityRead: 'Rate Read',
    verifyVelocityWrite: 'Rate Write',
  },
  home: {
    title: 'Risk Decision Platform',
    subtitle: 'Configure access points, rules, strategies, and decision flows',
  },
  systemArchitecture: {
    title: 'Risk Control System',
    subtitle: 'Overview of the risk control system architecture, including strategy decision, real-time engine, feature platform, and data infrastructure',
    s1: {
      title: '1.1 Strategy Decision Platform',
      accessPointMgmt: 'Access Point Management',
      strategyConfig: 'Strategy Configuration',
      versionMgmt: 'Version Management',
      decisionDashboard: 'Decision Dashboard',
    },
    s2: {
      title: '1.2 Real-time Decision Engine',
      onlineApp: 'Online Risk Control Application',
      accessCheck: 'Access Detection',
      decisionOrchestration: 'Decision Orchestration',
      decisionAction: 'Decision Action',
      decisionConclusion: 'Decision Conclusion',
      decisionComponent: 'Decision Component',
      splitRouting: 'Split Routing',
    },
    s3: {
      title: '1.3 Risk Operations Platform',
      merchantOps: 'Merchant Operations Platform',
      riskOps: 'Risk Operations Platform',
      deepQuery: 'Deep Query',
      actionProcess: 'Action Processing',
      caseWorkflow: 'Case & Workflow',
    },
    s4: {
      title: '1.4 Feature Platform',
      featureGovernance: 'Feature Governance',
      featureService: 'Feature Service',
      featureStorage: 'Feature Storage',
      featureCategory: 'Feature Category',
    },
    s5: {
      title: '1.5 Decision Data',
      dataCollection: 'Data Collection',
      collectionDimension: 'Collection Dimension',
      riskData: 'Risk Control Data',
      externalData: 'External Data',
    },
    s6: {
      title: '1.6 Data Service Providers',
    },
    s7: {
      title: '1.7 Risk Monitoring Center',
      metricMonitor: 'Metric Monitoring',
      featureMonitor: 'Feature Monitoring',
      alertCenter: 'Alert Center',
    },
    s8: {
      title: '2. Data & Infrastructure',
      onlineStorage: 'Online Storage',
      bizStorage: 'Business Storage',
      streamProcessing: 'Stream Processing',
    },
    s9: {
      title: '3. Shared Components Layer',
      ruleEngine: 'Rule Engine',
      statComponent: 'Statistical Components',
      designLanguage: 'Design Language',
    },
    s10: {
      title: '4. Long-term Extension Capabilities',
    },
  },
  fields: {
    sceneCode: 'Scene',
    sceneName: 'Scene Name',
    decisionTree: 'Decision Tree',
    defaultDecisionTree: 'Default Decision Tree',
    accessPoints: 'Access Points',
    fieldCode: 'Field Code',
    fieldName: 'Field Name',
    fieldValue: 'Field Value',
    accessPointCode: 'Access Point Code',
    accessPointName: 'Access Point Name',
    merchantNo: 'Merchant No',
    merchantName: 'Merchant Name',
    merchantId: 'Merchant ID',
    payType: 'Pay Type',
    orderAmount: 'Order Amount',
    dictCode: 'Dict Code',
    dictName: 'Dict Name',
    scope: 'Scope',
    enumCode: 'Enum Code',
    enumName: 'Enum Name',
    customFlag: 'Custom Flag',
    ruleCode: 'Rule Code',
    ruleName: 'Rule Name',
    ruleDesc: 'Rule Description',
    ruleType: 'Rule Type',
    scriptType: 'Script Type',
    scriptContent: 'Script Content',
    strategyCode: 'Strategy Code',
    strategyName: 'Strategy Name',
    featureCode: 'Feature Code',
    featureName: 'Feature Name',
    featureRateCode: 'Feature Rate Code',
    featureRateName: 'Feature Rate Name',
    treeCode: 'Tree Code',
    rateCode: 'Rate Code',
    treeName: 'Tree Name',
    treeType: 'Tree Type',
    commonFlag: 'Common Flag',
    versionDesc: 'Version Desc',
    flow: 'Flow',
    leftVersion: 'Left Version',
    rightVersion: 'Right Version',
    published: 'Published',
    lastPublishedTime: 'Last Published',
    riskLevel: 'Risk Level',
    reasonCode: 'Reason Code',
    actionCode: 'Action Code',
    riskConclusion: 'Risk Conclusion',
    score: 'Score',
    ruleScore: 'Rule Score',
    timeoutMs: 'Timeout (ms)',
    terminal: 'Terminal',
    order: 'Order',
    featureSource: 'Feature Type',
    valueType: 'Value Type',
    dimensionFlag: 'Is Rate Dimension Field',
    subWindowPeriod: 'Sub Window Period',
    calcType: 'Calc Type',
    windowType: 'Window Type',
    windowPeriod: 'Window Period',
    maxErrorRate: 'Max Error Rate (%)',
    keyDimensions: 'Key Dimensions',
    storageDimensions: 'Storage Dimensions',
    window: 'Window',
  },
  flowEditor: {
    hint: 'Drag to pan canvas; double-click node or use "View Strategy" to open details',
    viewStrategy: 'View Strategy',
    viewJson: 'Full Data',
    fitCanvas: 'Fit',
    edgeTrue: 'Success',
    edgeFalse: 'Failure',
    title: 'Decision Flow',
    paletteSelect: 'Select',
    paletteStart: 'Start',
    paletteRoute: 'Route',
    paletteStrategy: 'Strategy',
    paletteEnd: 'End',
    toolFullscreen: 'Fullscreen',
    toolZoomIn: 'Zoom In',
    toolZoomOut: 'Zoom Out',
    toolFit: 'Fit',
    toolPan: 'Pan',
    toolSelect: 'Select',
    toolMinimap: 'Minimap',
    toolDownload: 'Download',
    duplicateStart: 'Start node already exists on canvas',
    duplicateEnd: 'End node already exists on canvas',
    dragHint: 'Drag nodes from the left palette; move and connect in select mode',
  },
  scenes: {
    title: 'Scenes',
    create: 'Create Scene',
    edit: 'Edit Scene',
    detail: 'Scene Detail',
    basicInfo: 'Basic Info',
    dimensions: 'Dimensions',
    created: 'Scene created',
    updated: 'Scene updated',
  },
  accessPoints: {
    title: 'Access Points',
    create: 'Create Access Point',
    edit: 'Edit Access Point',
    dimensions: 'Dimensions',
    dimension: 'Dimension',
    operator: 'Operator',
    value: 'Value',
    dimensionPlaceholder: 'Select dimension',
    valuePlaceholder: 'Enter value',
    statusChanged: 'Status updated',
    created: 'Access point created',
    updated: 'Access point updated',
    sceneCodePlaceholder: 'Select scene',
    conditionTree: 'Condition Script',
    conditionTreePlaceholder: '{"type":"condition","operator":"eq","field":"F_CHANNEL","value":"APP"}',
    conditionTreeInvalid: 'Invalid condition tree JSON for dimension {field}',
  },
  sceneDicts: {
    title: 'Scene Dicts',
    create: 'Create Scene Dict',
    edit: 'Edit Scene Dict',
    enums: 'Enums',
    addEnum: 'Add Enum',
    editEnum: 'Edit Enum',
    created: 'Scene dict created',
    updated: 'Scene dict updated',
    enumManagement: 'Enum Management',
    deleteEnumConfirm: 'Delete this enum?',
    enumCreated: 'Enum created',
    enumUpdated: 'Enum updated',
    enumDeleted: 'Enum deleted',
    scopeCommon: 'Common',
    scopeScene: 'Scene',
  },
  merchantThresholds: {
    title: 'Merchant Thresholds',
    create: 'Create Threshold',
    edit: 'Edit Threshold',
    syncTitle: 'Sync from Template',
    created: 'Threshold created',
    updated: 'Threshold updated',
    synced: 'Thresholds synced',
    syncFieldPlaceholder: 'Optional — sync all if empty',
    manageTitle: 'Manage thresholds for merchant {merchantNo}',
    manage: 'Manage',
    merchantNoPlaceholder: 'Enter merchant no',
    merchantNamePlaceholder: 'Enter merchant name',
    riskLevelPlaceholder: 'Enter risk level',
  },
  merchantRules: {
    title: 'Merchant Custom Rules',
    create: 'Create Merchant Rule',
    edit: 'Edit Merchant Rule',
    detail: 'Merchant Rule Detail',
    basicInfo: 'Basic Info',
    templateConfig: 'Rule Template',
    thresholdConfig: 'Threshold Params',
    overrideConfig: 'Override (empty inherits platform default)',
    filterMerchantNoPlaceholder: 'Enter merchant no',
    filterRuleCodePlaceholder: 'Enter rule code',
    merchantNoPlaceholder: 'Enter merchant no',
    ruleCodePlaceholder: 'Select rule template',
    thresholdParamsHint: 'Dynamically generated from template placeholders',
    actionCodeInherit: 'Empty inherits platform default action',
    riskConclusionInherit: 'Empty inherits platform default conclusion',
    riskLevelInherit: 'Empty inherits platform default level',
    ruleScoreInherit: 'Empty inherits platform default score',
    created: 'Merchant rule created',
    updated: 'Merchant rule updated',
    deleted: 'Merchant rule deleted',
    disabled: 'Merchant rule disabled',
    enabled: 'Merchant rule enabled',
    statusChanged: 'Merchant rule status updated',
    deleteConfirm: 'Delete this merchant rule? Remaining rules will be republished',
    disableConfirm: 'Disable this merchant rule? Strategy will be republished',
    ruleCodeExists: 'This merchant already configured this rule, please edit instead',
    templateRequired: 'Please select a rule template first',
    noExposedTemplates: 'No exposed rule templates, please configure in template management',
    defaultAction: 'Platform default: {value}',
    defaultEmpty: 'No platform default value',
  },
  rules: {
    title: 'Rules',
    create: 'Create Rule',
    edit: 'Edit Rule',
    detail: 'Rule Detail',
    syntaxTestTitle: 'Rule Syntax Test',
    scriptComponent: 'Script Engine',
    ruleOutput: 'Output',
    filterNamePlaceholder: 'Rule name',
    filterCodePlaceholder: 'Rule code',
    created: 'Rule created',
    updated: 'Rule updated',
    statusChanged: 'Rule status updated',
    syntaxValid: 'Syntax valid',
    syntaxTestRequired: 'Please pass the syntax test before saving',
    basicInfo: 'Rule Info',
    scriptConfig: 'Rule Script',
  },
  strategies: {
    title: 'Strategies',
    create: 'Create Strategy',
    edit: 'Edit Strategy',
    detail: 'Strategy Detail',
    ruleRels: 'Rule Relations',
    syntaxTestTitle: 'Strategy Syntax Test',
    created: 'Strategy created',
    updated: 'Strategy updated',
    statusChanged: 'Strategy status updated',
    syntaxTestResult: 'Syntax Test Result',
    addRule: 'Add Rule',
    typeScriptRequired: 'Strategy type and script type are required',
    basicInfo: 'Basic Info',
    scriptConfig: 'Script Config',
    branchStrategy: 'Branch Strategy',
    createBranch: 'Create Branch',
  },
  features: {
    title: 'Feature Fields',
    create: 'Create Feature',
    edit: 'Edit Feature',
    metaFieldName: 'Meta Field',
    fieldFormat: 'Format',
    fieldSource: 'Feature Type',
    accessMode: 'Access Mode',
    filterNamePlaceholder: 'Field name',
    filterCodePlaceholder: 'Field code',
    created: 'Feature created',
    updated: 'Feature updated',
    statusChanged: 'Feature status updated',
    basicInfo: 'Basic Info',
    rateConfig: 'Rate Config',
    scriptConfig: 'Script Config',
  },
  featureRates: {
    title: 'Rate Config',
    create: 'Create Rate',
    edit: 'Edit Rate',
    detail: 'Rate Detail',
    factorCode: 'Factor Code',
    factorName: 'Factor',
    factorType: 'Factor Type',
    factorTag: 'Factor Tag',
    filterNamePlaceholder: 'Factor name',
    filterCodePlaceholder: 'Factor code',
    conditionTreeJson: 'Condition Tree (JSON)',
    created: 'Rate created',
    updated: 'Rate updated',
    statusChanged: 'Rate status updated',
    basicInfo: 'Basic Info',
    windowConfig: 'Window Config',
    dimensionConfig: 'Dimension Config',
    conditionConfig: 'Condition Config',
    keyDimensionsPlaceholder: 'Enter key dimension, press Enter',
    redisKeyExample: 'Redis Key Example',
    storageDimensionsPlaceholder: 'Enter storage dimension, press Enter',
  },
  decisionTrees: {
    title: 'Decision Flow',
    create: 'Create Decision Tree',
    edit: 'Edit Decision Tree',
    detail: 'Decision Tree Detail',
    compareVersions: 'Compare Versions',
    compareResult: 'Compare Result',
    basicInfo: 'Basic Info',
    versions: 'Versions',
    viewFlowJson: 'View Flow JSON',
    flowJson: 'Flow JSON',
    strategiesInFlow: 'Strategies in flow',
    invalidFlowJson: 'Invalid flow JSON',
    created: 'Decision tree created',
    updated: 'Decision tree updated',
    published: 'Published version {version}',
    left: 'Left',
    right: 'Right',
  },
  versionPublish: {
    title: 'Version Publish',
    placeholder: 'Publish directory and publish records are under construction. You can publish from the decision flow detail page for now.',
    goDecisionFlow: 'Go to Decision Flow',
  },
  decisionPublish: {
    title: 'Decision Publish',
    detail: 'Publish Detail',
    manage: 'Manage',
    versionHistory: 'Version History',
    compareVersions: 'Compare Versions',
    compareResult: 'Compare Result',
    published: 'Published version {version}',
  },
  verify: {
    traceSingle: 'Single Trace',
    executionInstances: 'Execution Instances',
    executionDetail: 'Execution Detail',
    conclusions: 'Risk Conclusions',
    conclusionDetail: 'Conclusion Detail',
    simulate: 'Simulation',
    lineage: 'Lineage Query',
    traceBatch: 'Batch Trace',
    velocityRead: 'Rate Read',
    velocityWrite: 'Rate Write',
    txnId: 'Transaction ID',
    endpointCode: 'Access Point',
    decisionTreeName: 'Decision Flow',
    txnStage: 'Txn Stage',
    conclusion: 'Conclusion',
    runMode: 'Run Mode',
    startTime: 'Start Time',
    hitRules: 'Hit Rules',
    orderInfo: 'Order Info',
    requestJson: 'Request JSON',
    requestJsonEmpty: 'No request JSON',
    executionChain: 'Execution Chain',
    ruleCode: 'Rule Code',
    queryType: 'Query Type',
    entityCode: 'Code',
    relatedFeatures: 'Related Features',
    relatedStrategies: 'Related Strategies',
    relatedDecisionTrees: 'Related Decision Trees',
    relatedRules: 'Related Rules',
    noLineageData: 'No lineage data',
    simulateInput: 'Simulation Input (JSON)',
    simulateExecute: 'Run Simulation',
    trace: 'Trace',
    query: 'Query',
    comingSoonTitle: 'Coming Soon',
    comingSoonDesc: 'This feature depends on feature-calculate or batch job infrastructure.',
    noTraceData: 'No decision record found for this transaction',
    simulateHint: 'Rule script syntax validation for QLExpress expressions.',
    simulateRuleTab: 'Rule Syntax',
    simulateDecisionTreeTab: 'Decision Flow Simulation',
    simulateDecisionTreeHint: 'Engine dry-run via test(); draft canvas XML by default. Disable "Use draft" to prefer latest published snapshot.',
    latestRequestLoaded: 'Loaded the latest request of this decision tree; key Id fields regenerated via Snowflake algorithm',
    noLatestRequest: 'No latest request found for this decision tree; please fill the simulation input manually',
    latestRequestFailed: 'Failed to load the latest request; please fill the simulation input manually',
    useDraftFlow: 'Use draft canvas',
    xmlSource: 'XML Source',
    decisionResult: 'Decision Result',
    ruleTraceList: 'Rule Traces',
    strategyTraceList: 'Strategy Traces',
    velocityReadHint: 'Read rate/feature cache directly from Redis. Example key: feature:rate:{rateCode}:{dimKey}',
    redisKey: 'Redis Key',
    redisDataType: 'Data Type',
    redisTtl: 'TTL (seconds)',
    redisExists: 'Exists',
    redisValue: 'Value',
    velocityWriteHint: 'Rate write is not available yet; use transaction flow or feature-calculate service.',
    matched: 'Matched',
    executionFlowCanvas: 'Decision Flow Execution Path',
    executionFlowEmpty: 'No canvas or execution trace available (legacy records may lack ext_info).',
    flowSource: 'Canvas Source',
    flowSourceSnapshot: 'Published Snapshot',
    flowSourceDefinition: 'Current Definition',
    executedStrategyCount: 'Executed Strategies',
    totalExecutionCost: 'Total Duration',
    executionChainEmpty: 'No execution chain data',
    chainNode: 'Node',
    chainResult: 'Result',
    chainCost: 'Duration',
    chainPass: 'Success',
    chainFail: 'Failed',
  },
  messages: {
    invalidJson: 'Invalid JSON',
    valid: 'Valid',
    invalid: 'Invalid',
    invalidConditionTreeJson: 'Invalid condition tree JSON',
  },
}
